/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { projectTypesControllerCreate } from "./projectTypesControllerCreate";
import { projectTypesControllerFindAll } from "./projectTypesControllerFindAll";
import { projectTypesControllerFindOne } from "./projectTypesControllerFindOne";
import { projectTypesControllerRemove } from "./projectTypesControllerRemove";
import { projectTypesControllerUpdate } from "./projectTypesControllerUpdate";

export function projectTypesService() {
  return { projectTypesControllerCreate, projectTypesControllerFindAll, projectTypesControllerFindOne, projectTypesControllerUpdate, projectTypesControllerRemove }
}